import { AttributeOptionPointSwatchComponent } from './attribute-option-point-swatch/attribute-option-point-swatch.component';
import { SymbolSizes, SymbolIDs } from './../../../types/drawing/symbol-set';
import { SymbolInfo, SymbolSet, IconSymbols } from 'app/types/drawing/symbol-set';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { ThisReceiver } from '@angular/compiler';

@Component({
  selector: 'app-attribute-option-point-styler',
  templateUrl: './attribute-option-point-styler.component.html',
  styleUrls: ['./attribute-option-point-styler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttributeOptionPointStylerComponent implements OnInit {
  private _ready = false;
  constructor(private cdr: ChangeDetectorRef) { }
  get symbols(): SymbolSet {
    return IconSymbols;
  };

  get isHalf(): boolean {
    return this._symbolSize == 'half';
  }
  get isDouble(): boolean {
    return this._symbolSize == 'double';
  }

  ngOnInit(): void {
    this._ready = true;
  }

  private _symbolSize: SymbolSizes = 'normal';
  @Input()
  set symbolSize(size: SymbolSizes) {
    this._symbolSize = size;
    this.Refresh();
  }
  get symbolSize(): SymbolSizes {
    return this._symbolSize;
  }
  get symbolScale() {
    switch (this._symbolSize) {
      case 'double':
        return 2;
      case 'half':
        return .5;
      default:
      case 'normal':
        return 1;
    }
  }

  private _color: string = '#000000';
  @Input()
  set color(clr: string) {
    this._color = clr;
    this.Refresh();
  }
  get color(): string { return this._color; }

  private _currentSymbol?: SymbolInfo;
  @Input()
  set symbol(info: SymbolInfo | undefined) {
    if (info === this._currentSymbol) {
      if ([info, this._currentSymbol].indexOf(undefined) < 0) return;
    }
    this._currentSymbol = info;
    const styleName = (info && info.css) ? info.css.split(' ').pop() : '';
    this.styleName = styleName ? styleName : '';
    this._offsetX = (!!info && info.offsetX) ? info.offsetX : 0;
    this._offsetY = (!!info && info.offsetY) ? info.offsetY : 0;
    this._solid = (info && info.solid) ? info.solid === true : false;
    this.Refresh();
    this.NotifyListeners();
  }
  get symbol(): SymbolInfo | undefined {
    return this._currentSymbol;
  }
  @Output()
  symbolChange = new EventEmitter<SymbolInfo | undefined>();
  @Output()
  symbolEnters = new EventEmitter<SymbolInfo>();
  get symbolCSS(): string {
    if (this.faStyle === 'regular') {
      return 'far ' + this._styleName;
    }
    return 'fas ' + this._styleName;
  }
  private _offsetX: number = 0;
  public set offsetX(offset: number) {
    this._offsetX = offset;
    this.Refresh();
  }
  public get offsetX(): number {
    return this._offsetX;
  }

  private _offsetY: number = 0;
  public set offsetY(offset: number) {
    this._offsetY = offset;
    this.Refresh();
  }
  public get offsetY(): number {
    return this._offsetY;
  }

  private _solid: boolean = true;
  public set faStyle(style: 'solid' | 'regular') {
    this._solid = (style === 'solid');
    this.Refresh();
    this.NotifyListeners();
  }
  public get faStyle(): 'solid' | 'regular' {
    return this._solid ? 'solid' : 'regular';
  }

  private _styleName: string = '';
  public set styleName(name: string) {
    if (name.substring(0, 2) !== 'fa') {
      name = 'fa-' + name;
    }
    this._styleName = name;
    this.NotifyListeners();
    this.Refresh();
  }
  public get styleName(): string {
    if (this._styleName.indexOf('fa-') > -1) {
      return this._styleName.substring(3);
    }

    return this._styleName;
  }
  @ViewChildren(AttributeOptionPointSwatchComponent) pointSwatches?: QueryList<AttributeOptionPointSwatchComponent>;

  GetSymbol(col: number, row: number): SymbolInfo | undefined {
    const index = (row * 4) + col;
    console.log(row, col, index);
    if (this.symbols.length <= index) return undefined;
    return this.symbols[index];
  }
  EnterSymbol(col: number, row: number): void {
    this.SelectSymbol(col,row);
    const symbol = this.GetSymbol(col,row);
    if(!!symbol) {
      this.symbolEnters.emit(symbol);
    }
  }
  SelectSymbol(col: number, row: number): void {
    const index = (row * 4) + col;
    if (this.symbols.length <= index) return;
    this.symbol = this.symbols[index];
    if (!!this.pointSwatches) {
      const swatch = this.pointSwatches.get(index);
      if (swatch) swatch.Focus();
    }
  }
  HandleSymbolDown(event: KeyboardEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  HandleSymbolKey(event: KeyboardEvent, col: number, row: number) {
    switch (event.code) {
      case 'ArrowUp':
        if (row > 0) {
          row -= 1;
        } else {
          row = 5;
        }
        break;
      case 'ArrowDown':
        if (row < 5) {
          row += 1;
        } else {
          row = 0;
        }
        break;
      case 'ArrowLeft':
        if (col > 0) {
          col -= 1;
        } else {
          col = 3;
        }
        break;
      case 'ArrowRight':
        if (col < 3) {
          col += 1;
        } else {
          col = 0;
        }
        break;
      case 'Space':
      case 'Enter':
        break;
      default:
        return;
    }
    this.SelectSymbol(col, row);
    if (event.cancelable) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  Refresh() {
    if (this._ready) {
      this.cdr.detectChanges();
    }
  }
  GetIconOffsetX(): string {
    const scale = this.symbolSize
    return (this.offsetX * this.symbolScale) + 'px';
  }
  GetIconOffsetY(): string {
    return -(this.offsetY * this.symbolScale) + 'px';
  }
  NotifyListeners() {
    const symbol: SymbolInfo = {
      css: this.symbolCSS,
      solid: this._solid,
      offsetX: this.offsetX,
      offsetY: this.offsetY,
      size: this.symbolSize
    }
    this._currentSymbol = symbol;

    this.symbolChange.emit(symbol);
  }

}
